import { IAppState } from '../../../AppModulesWrapper';

import { mapDynamicPricing } from '../../utils/config';

export function selectDynamicPricingData(state: IAppState): object {
  const { offer, dynamicPricingAttributes } = state.servicePickerWidget;

  return mapDynamicPricing({ offer, dynamicPricingAttributes });
}
